import React from "react";
import Slider from "react-slick";
import SliderImg from "../Assets/sliderImg.jpeg";
import ArrowLeft from "../Assets/chevron-left.png";
import ArrowRight from "../Assets/chevron-right.png";

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    nextArrow: (
      <img
        src={ArrowRight}
        style={{
          marginLeft: "-20px !important",
        }}
      />
    ),
    prevArrow: (
      <img
        src={ArrowLeft}
        style={{
          marginRight: "-20px !important",
        }}
      />
    ),
  };
  return (
    <section className="relative w-full">
      <Slider {...settings}>
        {[0, 1, 2, 3, 4].map((i) => {
          return (
            <div className="w-full h-[20rem]">
              <div
                style={{
                  backgroundImage: `url(${SliderImg})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
                className="w-full h-full rounded-2xl"
              />
            </div>
          );
        })}
      </Slider>
    </section>
  );
};

export default Carousel;
